import Vue from 'vue'
import appService from '../../server/app.service'
import _ from 'lodash'

const state = {
    languages: [],
    languageSelected: 'ita',
    translations: [],
    id: 0
}

const getters = {
    languages: state => state.languages,
    languageSelected: state => state.languageSelected,
    translations: state => state.translations,
}

const actions = {

    loadTranslation (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('loadTranslation', { translations: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)

        })
    },
    saveTranslation (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            if( data.success ) {
                context.commit('saveTranslationSuccess')
                this.dispatch('addMessage', data)
            } else {
                this.dispatch('addMessage', data)
            }
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)

        })
    },
    languageSelect(context, slug) {
        context.commit('languageSelect', slug)
    },
    resetLibrary () {
        state.languageSelected = 'ita',
        state.translations = []
    },

}

const mutations = {
    loadTranslation (state, data) {
        state.languages = data.translations.data.languages
        state.translations = data.translations.data.translations
    },
    saveTranslationSuccess () {
    },
    languageSelect (state, slug) {
        state.languageSelected = slug.slug
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
